import React from "react";

// Language Logos
import DotnetSDK from "components/svg/onboarding/apm/dotnet-core.svg";
import DotnetFrameworkLogo from "components/svg/onboarding/apm/dotnet-framework.svg";
import JavaLogo from "components/svg/onboarding/apm/java.svg";
import PhpLogo from "components/svg/onboarding/apm/php.svg";
import PythonLogo from "components/svg/onboarding/apm/python.svg";
import GoLogo from "components/svg/onboarding/apm/go.svg";
import NodeLogo from "components/svg/onboarding/apm/node.svg";
import RubyLogo from "components/svg/onboarding/apm/ruby.svg";
import scalaLogo from "assets/onboarding/apm/scala.png";
const ScalaLogo = () => <img src={scalaLogo} height="43" width="114" />;

// Language Instructions
import dotnetInstructions from "./instructions/dotnet";
import dotnetSDKInstructions from "./instructions/dotnetSDK";
import javaInstructions from "./instructions/java";
import phpInstructions from "./instructions/php";
import pythonInstructions from "./instructions/python";
import goInstructions from "./instructions/go";
import nodeInstructions from "./instructions/node";
import rubyInstructions from "./instructions/ruby";

// Operating Systems Logos
import LinuxLogo from "components/svg/onboarding/apm/linux.svg";
import WindowsLogo from "components/svg/onboarding/apm/windows.svg";
// import OsXLogo from "components/svg/onboarding/apm/osx.svg";

export const LANGUAGES = {
  dotnet: {
    name: ".NET Framework",
    color: "#68217A",
    Logo: DotnetFrameworkLogo,
    instructions: dotnetInstructions,
    supportedOperatingSystems: ["windows"],
  },
  dotnetSDK: {
    name: ".NET Core",
    color: "#68217A",
    Logo: DotnetSDK,
    instructions: dotnetSDKInstructions,
    supportedOperatingSystems: ["windows", "linux"],
  },
  go: {
    name: "Go",
    color: "#80C2E5",
    Logo: GoLogo,
    instructions: goInstructions,
    supportedOperatingSystems: ["linux"],
  },
  java: {
    name: "Java",
    color: "#58829E",
    Logo: JavaLogo,
    instructions: javaInstructions("Java"),
    supportedOperatingSystems: ["linux", "windows"],
  },
  node: {
    name: "Node.js",
    color: "#6CC04A",
    Logo: NodeLogo,
    instructions: nodeInstructions,
    supportedOperatingSystems: ["linux"],
  },
  php: {
    name: "PHP",
    color: "#6282B7",
    Logo: PhpLogo,
    instructions: phpInstructions,
    supportedOperatingSystems: ["linux"],
  },
  python: {
    name: "Python",
    color: "#FEE263",
    Logo: PythonLogo,
    instructions: pythonInstructions,
    supportedOperatingSystems: ["linux"],
  },
  ruby: {
    name: "Ruby",
    color: "#9C3834",
    Logo: RubyLogo,
    instructions: rubyInstructions,
    supportedOperatingSystems: ["linux"],
  },
  scala: {
    name: "Scala",
    color: "#DC322F",
    Logo: ScalaLogo,
    instructions: javaInstructions("Scala"),
    supportedOperatingSystems: ["linux", "windows"],
  },
};

export const OPERATING_SYSTEMS = {
  windows: {
    name: "Windows",
    color: "#0DADEA",
    Logo: WindowsLogo,
  },
  linux: {
    name: "Linux",
    color: "#FDB816",
    Logo: LinuxLogo,
  },
  // osx: {
  //   name: "OS X",
  //   color: "#979797",
  //   Logo: OsXLogo,
  // },
};
